import angular from 'angular';
import constants from 'app/constants';
import {
  alerts
} from 'app/components/global';
import {
  amDataService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService
} from 'app/services';
import controller from './attach-finding-folder.controller';
import directive from './attach-finding-folder.directive';


export default angular.module('app.components.advisory.auditTrail.attachFindingFolder', [
  alerts,
  amDataService,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
])
  .directive('amAttachFindingFolder', directive)
  .controller('AttachFindingFolderController', controller)
  .name;

console.log('app.components.advisory.auditTrail.attachFindingFolder created');
